import React, { useState } from "react";
import Reactportal from "../../Components/Reactportal/Reactportal";
import LoadDetails from "./LoadDetails";
import { useDispatch, useSelector } from "react-redux";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import { gql, useQuery } from "@apollo/client";
import "./ResultLP.scss";
import ResultTable from "./ResultTableLP/ResultTable";

export const BID_DETAILS_BY_LOAD_ID_QUERY_LP = gql`
  query BidDetailsByLoadId($createInput: RequiredBidDetails) {
    BidDetailsByLoadId(createInput: $createInput) {
      Account_ID
      Accountdata {
        _id
        UserId
        Unique_Id
        Aadhar_Number
        Organization_Type
        Service_Type
        Business_Address
        Business_Address_2
        Business_City
        Business_Name
        Business_Pan
        Is_Business_Pan_Verified
        Is_Self_Pan_Verified
        Business_Pincode
        Business_State
        Business_Town
        Residential_Town
        Email
        GST_Number
        Land_Line
        Mobile_Number
        Business_Mobile_Number
        Alternate_Mobile_Number
        Emergency_Mobile_Number
        Pan_Number
        Proprietor_Name
        Residential_Address
        Residential_Address_2
        Residential_City
        Residential_Pincode
        Residential_State
        Aadhar_Card
        Pan_Card
        Proprietor_Photo
        GST_Certificate
        Shop_Act_Licence
        Office_Board_Photo
        MSME_certificate
        Self_Declaration_video
        Other_Doc_1
        Other_Doc_2
        Bank_Name
        Name
        Search_Value
        Account_Type
        BankAccount_Type
        IFSC_Code
        Account_Number
        Cancelled_Cheque
        BankAccount_HolderName
        Visiting_Card
        Owned_Vehicles
        Total_Vehicles
        Is_Verified
        Is_Document_Verified
        Is_Lock
        Is_Mobile_Number_Verified
        Is_Email_Verified
        Is_Bank_Account_Lock
        Is_Pan_Verified
        Is_Gst_Verified
        Is_Bank_Verified
        Is_Aadhar_Verified
        KYC_Complete
        Not_Intrested
        Mobile_Number_Two
        Business_Mobile_Number_Two
        Business_Mobile_Number_Three
        Transporter_Type
        Directory_NonDirectory
        Not_Intrested_Remark
        Is_LaneAdded
        Is_VehicleTypeAdded
        DOB
        Life_Time_Bids
        TermsAndConditionAgreed
        TermsAndConditionAgreedOn
        Is_TMS_User
        EMT_LoadBoard
        createdAt
        updatedAt
      }
      Bid_History
      Bid_Note
      Bids {
        Advance_Processed_Time
        Advance_Processed
        Booking_Confirmed
        Challan_Demand
        Clear_Delivery_Confirmation
        Clear_Delivery_Confirmation_Time
        Consent_Status
        _id
        createdAt
        tripId
        updatedAt
        UserId
        Vehicle_Back_Img
        Vehicle_Capacity
      }
      Confirm_Qty
      LoadId
      No_Of_Vehicle
      Price
      Rank
      SP_Business_Name
      Supply_Partner_Contact
      Time_Of_Bid
      Trip_Bookings
      Unique_Id
      _id
      createdAt
      updatedAt
    }
  }
`;
// query BidDetailsForSp {
//   BidDetailsForSp {
//     _id
//     UserId
//     Account_ID
//     BidId {
//       _id
//       Rank
//     }
//     LoadId {
//       _id
//       Unique_Id
//       UserId
//       Is_Bid_Placed
//       Account_ID
//       Load_Post_Type
//       Auction_Date
//       Auction_Time
//       Dangerous_Goods
//       Exact_Content
//       Expected_Price
//       Target_Price
//       From_City
//       Load_Live_Duration
//       Load_Manager {
//         _id
//         FullName
//       }
//       Loading_Area
//       Loading_By
//       Loading_City
//       Loading_Date
//       Loading_Landmark
//       Loading_Name
//       Loading_Pincode
//       Loading_Town
//       Loading_Scope
//       Loading_State
//       Loading_Time
//       Loading_Address_Line_1
//       Loading_Address_Line_2
//       Material_Category {
//         _id
//         Material_Category_Name
//       }
//       Material_Dimension
//       Material_Dimension_In
//       Material_Insurence
//       Material_Image
//       Material_Image_2
//       Material_Image_3
//       No_Of_Vehicels_Required
//       No_Of_Vehicels_Loading_Completed
//       Notes
//       Over_Dimension_Cargo
//       Payment_Type {
//         _id
//         Name
//       }
//       Rate_per
//       To_City
//       Total_Weight
//       Unloading_Area
//       Unloading_City
//       Unloading_Landmark
//       Unloading_Name
//       Unloading_Pincode
//       Unloading_Town
//       Unloading_Scope
//       Unloading_State
//       Unloading_Address_Line_1
//       Unloading_Address_Line_2
//       Vehicle_Type_String
//       Vehicle_Type {
//         _id
//         Unique_Id
//         Vehicle_Type
//         User_ID
//         Search_Value
//         Serial_No
//         createdAt
//         updatedAt
//       }
//       Vehicle_Category_String

//       VehicleCategoryGroupData {
//         _id
//         VehicleType
//         VehicleCategory {
//           _id
//           Unique_Id
//           Name
//           User_ID
//           createdAt
//           updatedAt
//         }
//       }
//       Is_Live
//       Is_Auction_Started
//       Is_Archive
//       Total_Weight_In
//       L1
//       Private_Group_ID
//       Private_Contact_ID
//       Post_To_Private_Network
//       Post_To_EMT_Load_Board
//       Is_EMT_ASSURE
//       Is_Calls_Accepted
//       LP_Business_Name
//       Load_Manager_Contact
//       Payment_Percentage
//       createdAt
//       updatedAt
//     }
//     Unique_Id
//     Vehicle_Number {
//       _id
//       Unique_Id
//       UserId
//       Vehicle_No
//       RC_Data {
//         Registration_Number
//         ChassIs_No
//         Expiry_Date
//         Permit_Due_Date
//         Permit_Doc_No
//         Vehicle_Owner
//         Owner_Permanent_Address
//         PUCC_Due_Date
//         Vehicle_Category
//         Vehicle_Fitness_Expired
//         Vehicle_Type
//         Vehicle_Unladen_Weight
//       }
//       createdAt
//       updatedAt
//     }
//     Vehicle_Capacity
//     Loading_City
//     Unloading_City
//     Unloading_State
//     Loading_State
//     Loading_Pincode
//     Unloading_Pincode
//     Driver_Name
//     Driver_Number
//     Freight_Amount
//     Platform_Charges
//     Current_Stage
//     Reporting_Time
//     Is_Confirmed
//     Is_Accepted
//     Is_Rejected
//     tripId
//     Trip_Management
//     TripBooking_Confirmed
//     TripBooking_Confirmed_Time
//     Vehicle_Reached_At_Loading_Point
//     Vehicle_Reached_At_Loading_Point_Time
//     Loading_Completed
//     Loading_Completed_Time
//     Advance_Processed
//     Advance_Processed_Time
//     Vehicle_Reach_At_Unloading_Point
//     Vehicle_Reach_At_Unloading_Point_Time
//     Unloading_Completed
//     Unloading_Completed_Time
//     Clear_Delivery_Confirmation
//     Clear_Delivery_Confirmation_Time
//     POD_Collected_From_SP
//     POD_Submitted_To_LP
//     POD_Collected_From_SP_Time
//     POD_Submitted_To_LP_Time
//     Invoice_Number
//     Eway_Bill_Number
//     Eway_Bill_Created_Date
//     Eway_Bill_Validate_Date
//     Vehicle_Front_Img
//     Vehicle_Back_Img
//     Vehicle_Right_Img
//     Vehicle_Left_Img
//     Material_Img
//     Entry_Gate_Img
//     POD_Front_Copy
//     POD_Back_Copy
//     Invoice_Copy
//     Final_Invoice_Copy
//     Holding_Charges
//     Hamali_Charges
//     Extra_Running
//     Challan_Demand
//     Other_Charges
//     Other_Charges_Reason
//     Narration
//     Sp_Claim_Raised
//     Lp_Claim_Raised
//     Sp_Claim_Cleared
//     Lp_Claim_Cleared
//     Expired
//     Time_Out_Expired
//     GPS_Link
//     Sim_Tracking_Link
//     DL_Photo
//     LR_No
//     SP_Business_Name
//     Supply_Partner_Contact
//     Vehicle_Category_Name
//     createdAt
//     updatedAt
//   }
// }

// export const BID_DETAILS_BY_LOAD_ID_QUERY_LP = gql`
//   query BidDetailsForSp($createInput: RequiredBidDetails) {
//     BidDetailsForSp(createInput: $createInput) {
//       _id
//       LoadId
//       UserId
//       Price
//       Unique_Id
//       No_Of_Vehicle
//       Confirm_Qty
//       Committed_Vehicles {
//         _id
//         Unique_Id
//         UserId
//         LoadId {
//           _id
//           Unique_Id
//           Load_Post_Type
//           Auction_Date
//           Auction_Time
//           Dangerous_Goods
//           Exact_Content
//           Expected_Price
//           From_City
//           Load_Live_Duration
//           Load_Manager
//           Loading_Area
//           Loading_By
//           Loading_City
//           Loading_Date
//           Loading_Landmark
//           Loading_Name
//           Loading_Pincode
//           Loading_Scope
//           Loading_State
//           Loading_Time
//           Loading_Address_Line_1
//           Loading_Address_Line_2
//           Material_Category {
//             _id
//             Material_Category_Name
//           }
//           Material_Dimension
//           Material_Dimension_In
//           Material_Insurence
//           Material_Image
//           Material_Image_2
//           Material_Image_3
//           No_Of_Vehicels_Required
//           No_Of_Vehicels_Loading_Completed
//           Notes
//           Over_Dimension_Cargo
//           Payment_Type
//           Rate_per
//           Target_Price
//           To_City
//           Total_Weight
//           Unloading_Area
//           Unloading_City
//           Unloading_Landmark
//           Unloading_Name
//           Unloading_Pincode
//           Unloading_Scope
//           Unloading_State
//           Unloading_Address_Line_1
//           Unloading_Address_Line_2
//           Vehicle_Type_String
//           Vehicle_Category_String
//           Is_Live
//           Is_Auction_Started
//           Is_Archive
//           createdAt
//           updatedAt
//         }
//         BidId {
//           _id
//           LoadId
//           UserId
//           Price
//           Unique_Id
//           No_Of_Vehicle
//           Confirm_Qty
//           Committed_Vehicles
//           Bid_Note
//           createdAt
//           updatedAt
//         }
//         Vehicle_Number {
//           _id
//           Unique_Id
//           UserId
//           Vehicle_No
//           createdAt
//           updatedAt
//         }

//         Vehicle_Capacity
//         Driver_Name
//         Freight_Amount
//         Platform_Charges
//         Current_Stage
//         Driver_Number
//         Reporting_Time
//         Is_Confirmed
//         Is_Accepted
//         Is_Rejected
//         Booking_Confirmed
//         Booking_Confirmed_Time
//         Vehicle_Reached_At_Loading_Point
//         Vehicle_Reached_At_Loading_Point_Time
//         Loading_Completed
//         Loading_Completed_Time
//         Advance_Processed
//         Advance_Processed_Time
//         Vehicle_Reach_At_Unloading_Point
//         Vehicle_Reach_At_Unloading_Point_Time
//         Unloading_Completed
//         Unloading_Completed_Time
//         Clear_Delivery_Confirmation
//         Clear_Delivery_Confirmation_Time
//         POD_Collected_From_SP
//         POD_Submitted_To_LP
//         POD_Collected_From_SP_Time
//         POD_Submitted_To_LP_Time
//         Invoice_Number
//         Eway_Bill_Number
//         Eway_Bill_Created_Date
//         Eway_Bill_Validate_Date
//         Vehicle_Front_Img
//         Vehicle_Back_Img
//         Vehicle_Right_Img
//         Vehicle_Left_Img
//         Material_Img
//         Entry_Gate_Img
//         POD_Front_Copy
//         POD_Back_Copy
//         Invoice_Copy
//         Final_Invoice_Copy
//         Holding_Charges
//         Hamali_Charges
//         Extra_Running
//         Challan_Demand
//         Other_Charges
//         Other_Charges_Reason
//         Narration
//         Sp_Claim_Raised
//         Lp_Claim_Raised
//         Sp_Claim_Cleared
//         Lp_Claim_Cleared
//         Expired
//         Time_Out_Expired
//         createdAt
//         updatedAt
//       }
//       Bid_Note
//       createdAt
//       updatedAt
//     }
//   }
// `;
// ### Component Declaration
// `ResultLP` is a functional component that receives props (`fielddata`, `show`, `LoadId`, `totalWeight`, `setShowModal`, `loadVehicleDetails`, `TypeOfPortal`).
// It uses the `useQuery` hook to fetch bid details based on a provided load ID (`LoadId`). The query is customized with variables (ID, sorting parameters) and a specific GraphQL server indicated by a header.
// Redux's `useDispatch` is used to dispatch actions, and `useSelector` to access Redux store state (`FormFieldData`).

const ResultLP = ({ fielddata, show, LoadId, totalWeight, setShowModal, loadVehicleDetails, TypeOfPortal }) => {
  
  const dispatch = useDispatch();
  const [openItems, setOpenItems] = useState(show);
  
  // `useState` is used to manage the visibility of items (`openItems`) and initializes it with the `show` prop.

  // - `Closeformfunction2` is a function defined to close the modal (`setShowModal`) and reset the open state (`setOpenItems`) and clear specific data in the Redux store.
  const Closeformfunction2 = () => {
    setShowModal();
    setOpenItems(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };
  let submit = () => {};
  // The component renders a `Reactportal` with various props, indicating it's a modal or portal-type component.
  return (
    <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={"Result LP"}>
      <div className="mainResultDetailsdiv">
        {/* LoadDetails` component to display load-specific details with `LoadId` and a type. */}
        <LoadDetails LoadId={LoadId} Type={"ResultLP"} />
        {/* "BiddingPage" section containing a `ResultTable` for displaying bidding or vehicle requirement details. */}
        <div className="BiddingPage">
          <ResultTable
            loadId={LoadId}
            No_Of_Vehicels_Required={loadVehicleDetails.No_Of_Vehicels_Required}
            Load_Post_Type={loadVehicleDetails.Load_Post_Type}
          />
        </div>
      </div>
      {/* `PortalFooter` component is used for actions like submitting the form, canceling, or closing the modal, with handlers and states passed as props. */}
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        submitType={""}
        SaveAndClose={""}
        handleformclose={() => {
          Closeformfunction2();
          setOpenItems(false);
        }}
      />
    </Reactportal>
  );
};
export default ResultLP;
